import { FlexBox, Spinner } from '@dixa/lib-shared-habla';

import { presenceApi } from 'apis/presence';

import { SettingsAgentsWorkloadsForm } from './components/form/settingsAgentsWorkloadsForm';

export const SettingsAgentsWorkloadsView = (): JSX.Element => {
  const { isFetching } = presenceApi.useReadOrganizationWorkloadSettingsQuery();

  if (isFetching) {
    return (
      <FlexBox
        alignItems="center"
        justifyContent="center"
        height="100%"
        width="100%"
      >
        <Spinner />
      </FlexBox>
    );
  }

  return <SettingsAgentsWorkloadsForm />;
};
